import React, { PureComponent } from "react";
import { Field } from "redux-form/immutable";

import { SortableList } from "altus-ui-components";

import MuiOilrigIcon from "app/components/MuiOilrigIcon";
import { required, notEmpty } from "utils/validation.util";
import { CREATE_VIEW_GROUPS_FORM } from "features/planner/planner.constants";
import AddToSelectedItemsField from "features/planner/components/View/CreateViewGroups/AddToSelectedItemsField";

export default class PlanningGroupsList extends PureComponent {
  columns = [
    {
      xs: true,
      title: "Name",
      getSortProperty: planningGroup => planningGroup.getIn(["name"]),
    },
    {
      xs: true,
      title: "Modified by",
      getSortProperty: planningGroup => planningGroup.getIn(["modifiedBy"]),
    },
  ];

  actions = [
    {
      getValue: item => (
        <Field
          itemId={item.get("id")}
          validate={[required, notEmpty]}
          component={AddToSelectedItemsField}
          name={CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS}
        />
      ),
    },
  ];

  render() {
    const { planningGroups } = this.props;

    return (
      <SortableList
        minItems={10}
        displaySearchField
        Icon={MuiOilrigIcon}
        items={planningGroups}
        actions={this.actions}
        columns={this.columns}
        getKey={item => item.get("id")}
      />
    );
  }
}
